import { type RefObject, useEffect, useRef } from 'react';

export const useDialog = (
  open: boolean,
  onDismiss?: () => void,
): RefObject<HTMLDialogElement | null> => {
  const dialog = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (open && dialog.current) {
      dialog.current.showModal();
    }
    if (!open && dialog.current) {
      dialog.current.close();
    }
  }, [open]);

  useEffect(() => {
    const current = dialog.current;
    if (!current || !onDismiss) {
      return;
    }

    const dismiss = () => onDismiss();
    current.addEventListener('cancel', dismiss);

    return () => current.removeEventListener('cancel', dismiss);
  }, [onDismiss]);

  return dialog;
};
